import React, { useEffect, useState } from "react";
import { StorySubmission } from "../../../types";
import { useAppSelector } from "../../../redux/store";
import { constants } from "../../../constants";
import {
  selectAccessibility2,
  selectGameSettings,
  selectIsHost,
  selectPlayer,
} from "../../../redux/selectors";
import CensorButton from "../censor-button/censor-button";

type Variant = "read" | "censor" | "flag";

interface PrevSubmissionProps {
  submission: StorySubmission;
  variant: Variant;
  onToggle?: (submissionId: number, checked: boolean) => void;
}

const PrevSubmission: React.FC<PrevSubmissionProps> = ({
  submission,
  variant,
  onToggle,
}) => {
  const accessibility = useAppSelector(selectAccessibility2);
  const isHost = useAppSelector(selectIsHost);
  const gameSettings = useAppSelector(selectGameSettings);
  const player = useAppSelector(selectPlayer);

  const getInitialCheckedState = React.useCallback(() => {
    if (variant === "flag") {
      return submission.meta?.flagged?.includes(player?.id ?? -1) ?? false;
    }
    return submission.meta?.censored ?? false;
  }, [variant, submission.meta, player?.id]);

  const [isChecked, setIsChecked] = useState(getInitialCheckedState);

  useEffect(() => {
    setIsChecked(getInitialCheckedState());
  }, [getInitialCheckedState]);

  const canShowButton =
    (variant === "censor" && isHost && gameSettings.moderation && onToggle) ||
    (variant === "flag" &&
      gameSettings.moderation &&
      onToggle &&
      player?.id !== submission.player_id);

  const handleToggle = (checked: boolean) => {
    setIsChecked(checked);
    if (onToggle) {
      onToggle(submission.id, checked);
    }
  };

  return (
    <div>
      <div
        className={"break-words max-w-full"}
        style={constants.accessibleStyle(accessibility)}
      >
        {isChecked ? (
          <span className={"font-sans"}>■TEXT REMOVED■</span>
        ) : (
          submission.content
        )}
      </div>
      {canShowButton && (
        <CensorButton
          index={submission.id}
          onChange={handleToggle}
          checked={isChecked}
        />
      )}
    </div>
  );
};

export default PrevSubmission;
